import React from "react";

const ArrowImg = ({ SvgClass }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			className={SvgClass}>
			<path
				d="M4 6.40039L8 10.4004L12 6.40039"
				stroke="#111827"
				strokeWidth="1.67"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default ArrowImg;
